import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-[#171717] text-white">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-16 pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Column 1 - Brand */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.company')}</h3>
            <p className="text-sm text-[#E7E1D9] leading-relaxed max-w-[240px]">
              {t('footer.location')}
            </p>
          </div>

          {/* Column 2 - Solutions */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-[#E7E1D9] mb-5">{t('footer.solutions')}</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/solucoes" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.solutionItems.acquisition')}
              </Link>
              <Link to="/solucoes" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.solutionItems.construction')}
              </Link>
              <Link to="/solucoes" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.solutionItems.planning')}
              </Link>
              <Link to="/empresas" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.solutionItems.corporate')}
              </Link>
              <Link to="/cartas-contempladas" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.solutionItems.letters')}
              </Link>
            </nav>
          </div>

          {/* Column 3 - Institutional */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-[#E7E1D9] mb-5">{t('footer.institutional')}</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/metodo" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.institutionalItems.method')}
              </Link>
              <Link to="/sobre" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.institutionalItems.about')}
              </Link>
              <Link to="/conteudos" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('footer.institutionalItems.content')}
              </Link>
              <Link to="/contato" className="text-sm text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer">
                {t('nav.contact')}
              </Link>
            </nav>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-[#E7E1D9] mb-5">{t('footer.contact')}</h4>
            <div className="flex flex-col gap-3 text-sm text-[#E7E1D9]">
              <p>{t('footer.location')}</p>
              <a
                href={`tel:+5511930322408`}
                className="hover:text-[#F97700] transition-colors cursor-pointer"
              >
                {t('footer.phone')}
              </a>
              <a
                href={`mailto:contato@fgt-capital.com`}
                className="hover:text-[#F97700] transition-colors cursor-pointer"
              >
                {t('footer.email')}
              </a>
            </div>
          </div>
        </div>

        {/* Compliance Disclaimer */}
        <div className="mt-16 pt-6 border-t border-[#2E2E2E]">
          <p className="text-[13px] text-[#E7E1D9] text-center max-w-[960px] mx-auto leading-relaxed">
            {t('footer.compliance')}
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-[#2E2E2E] flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6 text-sm text-[#E7E1D9]">
            <span>{t('footer.copyright')}</span>
            <Link
              to="/privacidade"
              className="hover:text-[#F97700] transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('footer.privacy')}
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-5 h-5 flex items-center justify-center text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-5 h-5 flex items-center justify-center text-[#E7E1D9] hover:text-[#F97700] transition-colors cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
